'use client'

import { memo } from 'react'
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, Icon, useColorModeValue } from '@chakra-ui/react'
import { ChevronRight, Folder } from 'lucide-react'

const FolderBreadcrumb = ({ folderPath, onFolderSelect }) => {
  const activeLinkColor = useColorModeValue('blue.600', 'blue.300')

  return (
    <Breadcrumb
      spacing="8px"
      separator={<Icon as={ChevronRight} color="gray.500" boxSize={3} />}
      fontSize="sm"
      fontWeight="medium"
      overflow="hidden"
    >
      {folderPath.map((folder, index) => {
        const isLast = index === folderPath.length - 1

        return (
          <BreadcrumbItem key={folder.id} isCurrentPage={isLast} isLastChild={isLast}>
            <BreadcrumbLink
              onClick={() => onFolderSelect(folder.id)}
              color={isLast ? activeLinkColor : 'inherit'}
              fontWeight={isLast ? 'semibold' : 'medium'}
              display="flex"
              alignItems="center"
              maxWidth="200px"
              whiteSpace="nowrap"
              overflow="hidden"
              textOverflow="ellipsis"
              _hover={{ textDecoration: 'none', color: activeLinkColor }}
            >
              {index === 0 && <Icon as={Folder} boxSize={3} mr={1} />}
              {folder.name}
            </BreadcrumbLink>
          </BreadcrumbItem>
        )
      })}
    </Breadcrumb>
  )
}

export default memo(FolderBreadcrumb)
